<div
  [className]="
    (!!info.margin ? info.margin : 'mt-24') +
    ' relative flex flex-column radius-8M flex-wrap'
  ">
  <div
    *ngIf="info.topLabel"
    class="p-absolute ml-8 f12 px-16 inline-block white py-8 radius-25 background-purple top-m-14"
    [ngClass]="{
      'background-psr-link': !isSpecial,
      'background-purple': isSpecial
    }">
    {{ info.topLabel }}
  </div>

  <div *ngIf="info.list">
    <app-title-desc
      classDesc="f16 m-0 mb-10"
      classTitle="f16 m-0 mb-8"
      [desc]="info.description"
      [title]="info.title">
    </app-title-desc>

    <app-simple-info
      *ngFor="let point of info.listOfPoints; index as indexPoint"
      [classDiv]="indexPoint > 0 ? 'pt-8' : ''"
      [info]="point">
    </app-simple-info>
  </div>

  <div
    *ngIf="!info.isSimple"
    class="px-12 py-16 radius-8 mb-12 flex-g-1"
    [ngClass]="{
      'block background-psr-link-17': isSpecial,
      'bg-shadow-opacity': !isSpecial
    }">
    <p [ngClass]="{ 'text-left': isSpecial, 'text-center': !isSpecial }">
      <span class="f18 fw-bold" [ngClass]="{ 'block f24': isSpecial }">
        {{ info.value }}
      </span>
      <span class="f13">
        {{ info.description }}
      </span>
    </p>
  </div>

  <div *ngIf="info.isSimple && !detail">
    <p *ngIf="info.value" class="f15 fw-bold my-8">{{ info.value }}</p>
    <p class="f13 m-0">
      {{ info.description }}
      <a
        *ngIf="info.extraInfo"
        class="color-psr-link"
        [href]="info.extraInfo.link">
        {{ info.extraInfo.label }}
      </a>
    </p>
    <div *ngIf="isSpecial && info.value" class="divider my-16"></div>
  </div>

  <p *ngIf="info.extraMessage && !detail" class="f12 my-4 flex-g-1">
    {{ info.extraMessage }}
  </p>
</div>
